<div class="container container-lg p-0">
  <div class="detail-header">

    <div class="detail-header__main">

      <!-- Logo -->
      <div class="detail-header__logo__outer">
        <div class="detail-header__logo__inner"
          *ngIf="holidayDetails?.tourOperatorId && !holidayDetails?.logo"
          [ngStyle]="{'background-image': 'url(' + (holidayDetails?.tourOperatorId | imageByCode:'top') + ')'}">
        </div>
        <div class="detail-header__logo__inner" *ngIf="holidayDetails?.logo"
          [ngStyle]="{'background-image': 'url(' + (holidayDetails?.logo) + ')'}">
        </div>
      </div>

      <div class="detail-header__info">
        <!-- Nome struttura / titolo esperienza -->
        <h1 class="detail-header__accomodation">
          <span>{{holidayDetails?.title ? holidayDetails?.title : holidayDetails?.accomodation?.name}}</span>
          <span class="detail-header__stars" *ngIf="holidayDetails?.accomodation?.category?.value">{{holidayDetails.accomodation.category.value}}
            <i *ngIf="holidayDetails?.accomodation?.category?.icon" [class]="holidayDetails.accomodation.category.icon"></i></span>
        </h1>

        <!-- Località -->
        <span class="detail-header__destination">
          {{holidayDetails?.place.name}}, {{(holidayDetails?.place.parentId | getDataFromMapping:'destination' |
          async)?.Name + (holidayDetails?.searchSolution?.basis?.name ? ',':'')}}
          {{holidayDetails?.searchSolution?.basis?.name ?holidayDetails?.searchSolution?.basis?.name + ',' :''}} {{holidayDetails?.searchSolution?.nights ? holidayDetails?.searchSolution?.nights + ' notti' : ''}}
        </span>
      </div>

    </div>

  </div>
</div>
